import { Group } from "three";
import { Utils } from "../../Utils/Utils.js";
import { Cone } from "../Primitive/Cone.js";
export class DraggableCone extends Group {
    constructor(color, radius, height) {
        super();
        this.add(this.cone = new Cone(color, radius, height).translateY(height / 2));
        this.objectsToRaycast = [this.cone];
        this.isDraggable = true;
        this.bindEvent("onHover", () => {
            const scene = Utils.getScene(this);
            scene?.outlinePass && (scene.outlinePass.selectedObjects = [this]);
            this.needsRender = true;
        });
        this.bindEvent("onLeave", () => {
            const scene = Utils.getScene(this);
            scene?.outlinePass && (scene.outlinePass.selectedObjects = []);
            this.needsRender = true;
        });
    }
}
//# sourceMappingURL=DraggableCone.js.map